import type {
    StripePaymentInfo,
    StripeProductsResponse,
    StripeSubscriptionResponse,
    UserGrant,
} from '~/@types/backend-types'

import { createActionCreator, createVoidActionCreator } from '../common/actions'

export const RefusedSubscription = createVoidActionCreator('REFUSED_SUBSCRIPTION')

export const PurchaseStarted = createVoidActionCreator('PURCHASE_STARTED')
export const PurchaseSucceeded = createVoidActionCreator('PURCHASE_SUCCESSFUL')
export const PurchaseFailed = createVoidActionCreator('PURCHASE_FAILED')

export const PlanChangeStarted = createVoidActionCreator('PLAN_CHANGE_STARTED')
export const PlanChangeSucceeded = createActionCreator<{ newPlanID: string }>(
    'PLAN_CHANGE_SUCCEEDED',
)
export const PlanChangeFailed = createVoidActionCreator('PLAN_CHANGE_FAILED')
export const PlanChangeActionRequired = createActionCreator<string>('PLAN_CHANGE_ACTION_REQUIRED')
export const PlanChangeActionRequiredHandled = createVoidActionCreator(
    'PLAN_CHANGE_ACTION_REQUIRED_HANDLED',
)

export const PaymentInfoFetched = createActionCreator<StripePaymentInfo | null>(
    'PAYMENT_INFO_FETCHED',
)
export const StorageProductsFetched = createActionCreator<StripeProductsResponse>(
    'STORAGE_PRODUCTS_FETCHED',
)
export const UserStoragePlanFetched = createActionCreator<UserGrant[]>('USER_STORAGE_PLAN_FETCHED')

export const PlanCanceled = createVoidActionCreator('PLAN_CANCELED')
export const PlanCancelFailed = createVoidActionCreator('PLAN_CANCEL_FAILED')
export const PlanReactivated = createVoidActionCreator('PLAN_REACTIVATED')
export const PlanReactivationFailed = createVoidActionCreator('PLAN_REACTIVATION_FAILED')

export const StripeSetupIntentCreated = createActionCreator<string>('STRIPE_SETUP_INTENT_CREATED')

export const FetchStripeSubscriptionInfoSucceeded = createActionCreator<StripeSubscriptionResponse>(
    'FETCH_STRIPE_SUBSCRIPTION_INFO_SUCCEEDED',
)
export const FetchStripeSubscriptionInfoFailed = createVoidActionCreator(
    'FETCH_STRIPE_SUBSCRIPTION_INFO_FAILED',
)
